<template>
  <div>
    <div class='h-olap-search-area'>
      <ejs-textbox :placeholder='searchHolder' v-model='keywords'></ejs-textbox>
      <ejs-button :isPrimary='true' @click.native='queryByNum' cssClass='olap-search-button'>{{$t('TS.ts_search')}}</ejs-button>
    </div>
    <div class='h100-47 h-scroll'>
      <ejs-grid ref='grid' height='calc(100vh - 520px)' :dataSource='data' :allowSorting='true' :allowReordering='true' :allowResizing='true'>
        <e-columns>
          <e-column field='isCaller' minWidth='10' :headerText='$t("TS.ts_call_isCaller")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='isCallerFormat'></e-column>
          <e-column field='callType' minWidth='10' :headerText='$t("TS.ts_call_callType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='callTypeFormat'></e-column>
          <!--<e-column field='groupNum' minWidth='10' :headerText='$t("TS.ts_call_groupNum")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='groupNumFormat'></e-column>-->
          <!--<e-column field='callingType' minWidth='10' :headerText='$t("TS.ts_call_callingType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='callingTypeFormat'></e-column>-->
          <e-column field='callingAddress' minWidth='10' :headerText='$t("TS.ts_call_callingAddress")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <!--<e-column field='calledType' minWidth='10' :headerText='$t("TS.ts_call_calledType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='calledTypeFormat'></e-column>-->
          <e-column field='calledAddress' minWidth='10' :headerText='$t("TS.ts_call_calledAddress")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='beginTime' minWidth='10' :headerText='$t("TS.ts_call_beginTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' type='dateTime' format='yyyy-MM-dd HH:mm:ss'></e-column>
          <e-column field='startTime' minWidth='10' :headerText='$t("TS.ts_call_startTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' type='dateTime' format='yyyy-MM-dd HH:mm:ss'></e-column>
          <e-column field='endTime' minWidth='10' :headerText='$t("TS.ts_call_endTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' type='dateTime' format='yyyy-MM-dd HH:mm:ss'></e-column>
          <e-column field='callingTotalTime' minWidth='10' :headerText='$t("TS.ts_call_callingTotalTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='callCause' minWidth='10' :headerText='$t("TS.ts_call_callCause")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='callCauseFormat'></e-column>
          <e-column field='callFailReason' minWidth='10' :headerText='$t("TS.ts_call_callFailReason")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='priority' minWidth='10' :headerText='$t("TS.ts_call_priority")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <!--<e-column field='emergencyCall' minWidth='10' :headerText='$t("TS.ts_call_emergencyCall")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='emergencyCallFormat'></e-column>-->
          <e-column field='e2EE' minWidth='10' :headerText='$t("TS.ts_call_e2EE")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='e2EEFormat'></e-column>
          <!--<e-column field='duplexMode' minWidth='10' :headerText='$t("TS.ts_call_duplexMode")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='duplexModeFormat'></e-column>-->
          <e-column field='audioCode' minWidth='10' :headerText='$t("TS.ts_call_audioCode")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='getListData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../plugins/eventBus';
import Global from '../Global';
import { Reorder, Resize, Sort } from '@syncfusion/ej2-vue-grids';
export default {
  name: 'CalledDetailGrid',
  data() {
    return {
      olapUrl: Global.olapUrl,
      searchHolder: this.$t('TS.searchByNumHolder'),
      keywords: '',
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },
      queryConditions: {},
      data: [],
      primaryDatas: [],
    };
  },
  provide: {
    grid: [Reorder, Resize, Sort]
  },
  methods: {
    callTypeFormat(grid, data) {
      if (data.callType !== null && data.callType !== '') {
        const { callType } = data;
        switch (callType) {
          case 1:
            return this.$t('TS.ts_chart_single_call');
          case 2:
            return this.$t('TS.ts_chart_group_call');
          case 3:
            return this.$t('TS.ts_chart_single_video');
          case 4:
            return this.$t('TS.ts_chart_group_video');
          case 5:
            return this.$t('TS.ts_chart_broadcast_call');
          default:
            return callType;
        }
      } else {
        return '';
      }

    },
    groupNumFormat(grid, data) {
      if (data.groupNum !== null && data.groupNum !== '') {
        return data.groupNum;
      } else {
        return '--';
      }
    },
    isCallerFormat(grid, data) {
      if (data.isCaller !== null && data.isCaller !== '') {
        return this.$t(`TS.isCallerStatus_${data.isCaller}`);
      } else {
        return '';
      }

    },
    callingTypeFormat(grid, data) {
      if (data.callingType !== null && data.callingType !== '') {
        return this.$t(`TS.callingTypeStatus_${data.callingType}`);
      } else {
        return '';
      }
    },
    calledTypeFormat(grid, data) {
      if (data.calledType !== null && data.calledType !== '') {
        return this.$t(`TS.callingTypeStatus_${data.calledType}`);
      } else {
        return '';
      }
    },
    callCauseFormat(grid, data) {
      if (data.callCause !== null && data.callCause !== '') {
        return this.$t(`TS.callCauseStatus_${data.callCause}`);
      } else {
        return '';
      }
    },
    emergencyCallFormat(grid, data) {
      if (data.emergencyCall !== null && data.emergencyCall !== '') {
        return this.$t(`TS.emergencyCallStatus_${data.emergencyCall}`);
      } else {
        return '';
      }
    },
    e2EEFormat(grid, data) {

      if (data.e2EE !== null && data.e2EE !== '') {
        return this.$t(`TS.e2EEStatus_${data.e2EE}`);
      } else {
        return '';
      }
    },
    duplexModeFormat(grid, data) {
      if (data.duplexMode !== null && data.duplexMode !== '') {
        return this.$t(`TS.duplexModeStatus_${data.duplexMode}`);
      } else {
        return '';
      }
    },
    queryByNum(){
      this.getListData();
    },
    setQueryParams(params) {
      this.page.pageSize = 10;
      this.queryConditions = params;
      this.keywords = '';
      this.getListData();
    },
    getListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      const params = {
        neId: This.queryConditions.neId,
        uuid: This.queryConditions.uuid,
        beginTime: This.queryConditions.beginTime,
        num: This.keywords,
        isCaller: 0,
        pageNo: parseInt(This.page.pageNo, 10),
        pageSize: parseInt(This.page.pageSize, 10)
      };
      This.$loading.showLoadding(this.$t('MML.loadingTip'));
      This.$axios.post(`${This.olapUrl}/lte/ems/olap/voice/getCallDetail`, params).then((response) => {
        if (response && response.status === 200) {
          const result = response.data;
          This.page.totalCount = result.total;
          This.data = result.list;
          This.primaryDatas = This.data;
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
        This.$loading.hideLoadding();
      }).catch(err => {
        This.$loading.hideLoadding();
      });

    }
  }
};
</script>

<style scoped>


  .h-olap-search-area{
    white-space: nowrap;
    display: inline-block;
    margin-bottom: 15px
  }
  .olap-search-button{
    margin-left:10px
  }
</style>
